import './footer.css';
import React from 'react'
import {
    useNavigate
} from "react-router-dom";

const Footer = props => {
  const navigate = useNavigate();
 
  const navigateMyEkukka = () => {
    navigate('/myeKukka');
  };
  const navigateUserAgreement = () => {
    navigate('/userAgreement');
  };

  /*
  useEffect(() => {
    var contentHeight = document.getElementById('body').offsetHeight;
    console.log(contentHeight)
  }, []); 
  */
 

  return (
    <div id="footer">
      <div className="footer_content">
        <div className="footer_container">
          <div className="footer_top footer">
            <div className="section section1">
              <span className="footer_topic">Oma eKukka</span>
              <span className="footer_links">
                <ul>
                <li>
                  <a  href="/myeKukka" className="disabled" onClick={navigateMyEkukka} >Oma eKukka -jäsenyys</a>
                </li>
                <li>
                  <a  href="/#" className="disabled" onClick={navigateUserAgreement}>Käyttöehdot</a>
                </li>
                <li>
                  <a href="https://ekukka.fi/cookies_setting.php" target="_blank" rel="noreferrer">Tietosuojaseloste</a>
                </li>
                <li>
                  <a href="https://ekukka.fi/cookies_setting.php" target="_blank" rel="noreferrer">Evästekäytännöt</a>
                </li>
                </ul>
              </span>
            </div>
            <div className="section section2">
              <span className="footer_topic">Yhteystiedot</span>
              <span className="footer_links">
                <ul>
                <li>
                  <a href="https://ekukka.fi/" target="_blank" rel="noreferrer">eKukka.fi - Kukkien koti</a>
                </li>
                <li>
                  <a href="https://floweb.fi/" target="_blank" rel="noreferrer">Floweb Oy</a>
                </li>
                <li>
                  <a href="/#"  className="disabled" >info@ekukka.fi</a>
                </li>
                <li>
                  <a href="https://ekukka.fi/anna-palautetta.php" target="_blank" rel="noreferrer">Anna palautetta</a>
                </li>
                </ul>
              </span>
            </div>
            <div className="section section3"></div>
            <div className="section section4"></div>
          </div>
          <div className='footer_bottom footer'>  &copy; Floweb</div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
